import React from "react"
import { FormControl, OverlayTrigger } from "react-bootstrap"
import FieldTypes from "src/pages/dynamic_forms/Types/FieldTypes"
import DynamicFormPaletteTypes from "src/store/DyanmicFormPalette/types"
import TrashCan from "src/pages/dynamic_forms/Utils/TrashCan/TrashCan"
import paletteEngine from "src/pages/dynamic_forms/Utils/paletteEngine"
import mobileFriendlyWarning from "src/pages/dynamic_forms/Utils/MobileFriendlyWarning/MobileFriendlyWarning"
import reoccuringText from "src/pages/dynamic_forms/Utils/ReoccuringText"
import "./StaticText.css"
import "../../DynamicForm.css"

interface Props {
    manageParentState: Function
    handleChange: Function
    field: FieldTypes
    row: number
    col: number
    formManagerField?: boolean
    configField?: boolean
    templateField?: boolean
    remove: Function
    palette: Array<DynamicFormPaletteTypes>
    readOnly?: boolean
}

function StaticText(props: Props) {

    // console.log("df_StaticTextField props", props)

    const field = props.field
    const name = field.Name || "Static text"
    const values = field.CustomValues || []
    const templateField = props.templateField
    const formManagerField = props.formManagerField
    const configField = props.configField
    const fieldType = templateField ? "TemplateField" : formManagerField ? "FormMangerField" : configField ? "ConfigField" : "Field"

    const handleAddOrDelete = (index?: number) => {
        let temp = values || []
        props.manageParentState([{ key: "target", value: { row: props.row, col: props.col, key: "CustomValues" } }])
        if (typeof (index) === "number") {
            temp.splice(index, 1)
        } else {
            temp.push("")
        }
        props.handleChange({ target: { value: temp } })
    }

    const buildLinkMap = () => {
        let map = []
        for (let i = 0; i < values.length; i++) {
            if (field.LinkMap && field.LinkMap[i]) {
                map[i] = field.LinkMap[i]
            } else {
                map[i] = { checked: false, title: null }
            }
        }
        return map
    }

    const linkMap = buildLinkMap()

    return (
        <div className={`DynamicForm${fieldType} DynamicStaticText${fieldType}`} style={{ backgroundColor: `${paletteEngine.getPaletteColor("fieldBackgroundColor")}` }}>
            <div className="DynamicFormFieldHeader">
                {!formManagerField && <div className="DynamicFormFieldHeaderLeft">
                    <p style={{ color: `${paletteEngine.getPaletteColor("headerTextColor")}` }}>{name}</p>
                </div>}
                <div className="DynamicFormFieldHeaderRight">
                    {templateField && <div className="DynamicFormFieldHeaderRightSettings">
                        <div className="DynamicFormFieldHeaderRightSettingsMultiColumnarWarning">
                            {props.col > 0 &&
                                <OverlayTrigger placement="right" overlay={mobileFriendlyWarning("Rows with multiple columns", reoccuringText.multipleColumnInRowWarningText)}>
                                    <span
                                        className="material-icons"
                                        style={{ color: `${paletteEngine.getPaletteColor("editorConfigMultiColumnsWarningIconColor")}` }}>
                                        priority_high
                                    </span>
                                </OverlayTrigger>}
                        </div>
                        <span className="material-icons DynamicFormFieldHeaderRightSettingsGear"
                            style={{ color: `${paletteEngine.getPaletteColor("editorConfigGearColor")}` }}
                            onClick={() => props.manageParentState([{ key: "configTarget", value: { row: props.row, col: props.col } }])}>
                            settings
                        </span>
                        <TrashCan clickCallback={() => props.remove(field.Type, props.row, props.col, true)} color={`${paletteEngine.getPaletteColor("editorTrashBinColor")}`} />
                    </div>}
                </div>
            </div>
            <div className="DynamicFormFieldBody">
                {configField && <div className="DynamicFormFieldBodyStaticTextConfigInputs">
                    {values && values.map((item: string | null, i: number) =>
                        <div className="DynamicFormFieldBodyStaticTextConfigInput" key={`static-text-config-input-${i}`}>
                            <div className="DynamicFormFieldBodyStaticTextConfigInputLeft">
                                {i > 0 && <TrashCan clickCallback={() => handleAddOrDelete(i)} color={`${paletteEngine.getPaletteColor("editorTrashBinColor")}`} />}
                            </div>
                            <div className="DynamicFormFieldBodyStaticTextConfigInputRight">
                                <FormControl onFocus={() => props.manageParentState([{ key: "target", value: { row: props.row, col: props.col, key: "CustomValues" } }])}
                                    onChange={(e) => {
                                        const input = e.target.value
                                        let temp = values
                                        temp[i] = input
                                        props.handleChange({ target: { value: temp } })
                                    }}
                                    placeholder={"Static Text..."}
                                    value={item || ""}
                                    as="textarea"
                                    rows={5}
                                    style={{ backgroundColor: `${paletteEngine.getPaletteColor("fieldInputBackgroundColor")}`, color: `${paletteEngine.getPaletteColor("fieldInputTextColor")}` }}
                                />
                                {/*******************************************************Link**********************************************************************/}
                                <div className="DynamicFormFieldBodyStaticTextIsLink">
                                    <div className="DynamicFormFieldBodyStaticTextHeader" >
                                        <p style={{ color: `${paletteEngine.getPaletteColor("headerTextColor")}` }} >Is Link?</p>
                                    </div>
                                    <FormControl onFocus={() => props.manageParentState([{ key: "target", value: { row: props.row, col: props.col, key: "LinkMap" } }])}
                                        //@ts-ignore
                                        value={field.Value || ""}
                                        checked={linkMap[i].checked}
                                        onChange={() => {
                                            let temp = linkMap
                                            temp[i].checked = !temp[i].checked
                                            props.handleChange({ target: { value: temp } })
                                        }}
                                        type="checkbox"
                                    />
                                </div>
                                {linkMap[i].checked && <FormControl onFocus={() => props.manageParentState([{ key: "target", value: { row: props.row, col: props.col, key: "LinkMap" } }])}
                                    onChange={(e) => {
                                        const input = e.target.value
                                        let temp = linkMap
                                        temp[i].title = input
                                        props.handleChange({ target: { value: temp } })
                                    }}
                                    placeholder={"Link title"}
                                    value={linkMap[i].title || ""}
                                    style={{ backgroundColor: `${paletteEngine.getPaletteColor("fieldInputBackgroundColor")}`, color: `${paletteEngine.getPaletteColor("linkColor")}` }}
                                />}
                            </div>
                        </div>)}
                    <div className="DynamicFormFieldBodyStaticTextConfigInputsAddItem">
                        <span className="material-icons" onClick={() => handleAddOrDelete()}>add</span>
                    </div>
                </div>}
                {!configField && <div className="DynamicFormFieldBodyStaticTextItems" style={{ backgroundColor: `${paletteEngine.getPaletteColor("fieldInputBackgroundColor")}` }}>
                    {values && values.map((item, i) =>
                        <div className={`DynamicFormFieldBodyStaticTextItem DynamicFormFieldBodyStaticTextItem${values.length > 1 ? "MultipleItems" : "SingleItem"}`} key={`statc-text-item-${i}`}>
                            {/* {!linkMap[i].checked && <p>{values.length > 1 && <span>{`${i + 1}. `}</span>}{item}</p>} */}
                            {!linkMap[i].checked && <p style={{ color: `${paletteEngine.getPaletteColor("fieldInputTextColor")}` }}>{item}</p>}
                            {/*@ts-ignore*/}
                            {linkMap[i].checked && <a style={{ color: `${paletteEngine.getPaletteColor("linkColor")}` }} href={item} target={"_blank"} rel="noreferrer">{linkMap[i].title || "Click here"}</a>}
                        </div>
                    )}
                </div>}
            </div>
        </div>
    )
}

export default StaticText